module.exports = function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
};



//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_isString.js
// module id = 41
// module chunks = 35783957827783 114276838955818